// state is not the application state, only the state this
// reducer is responsible for.
import {FETCH_GAME, GAME_SELECTED, CREATE_GAME} from "../constants/ActionTypes";
import {isString} from "lodash/lang";

// Returns a single game object, or is this just a game id?
export default function (state = null, action) {

    switch (action.type) {
        // payload is always game -- but our state is just the id.  The game "truth" is always in the games area in the games state.
        case GAME_SELECTED:
            //game = action.payload;
            if (action.payload && !isString(action.payload)) {
                alert("Selected game in reducer is not a string (game id)");
                return state;
            }
            return action.payload;
        case FETCH_GAME:
            const game = action.payload;
            if (game) {
                return game.id;
            } else {
                return state;
            }
        case CREATE_GAME:
            if (action.payload) {
                const newGameData = action.payload;
                const id = newGameData.id;

                return id;
            } else {
                return state;
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_active_game.js